<template>
    <typo :class="cspClasses" name="ci-body">
        <v-card class="insurer-wrapper" elevation="3">
            <div class="insurer-card">
                <div class="insurer-body">
                    <ul class="insurer-list">
                        <li v-for="insurer in annotationInsurers" :key="insurer._uid">
                            {{ insurer.label }}
                        </li>
                    </ul>
                    <div class="insurer-dates">
                        <div v-if="startDate">
                            Depuis le <strong>{{ startDate }}</strong>
                        </div>
                        <div v-if="expiryDate">
                            Expire le <strong>{{ expiryDate }}</strong>
                        </div>
                    </div>
                    <div class="insurer-badges">
                        <span v-if="insuranceTypeLabel" class="insurer-badge">
                            {{ insuranceTypeLabel }}
                        </span>
                        <span v-if="annotation.highSolidarityDegree" class="insurer-badge">
                            Degré élevé de solidarité
                        </span>
                    </div>
                </div>
                <div class="insurer-guaranties">
                    <typo name="body-16-normal">Garanties</typo>
                    <sep name="S"></sep>
                    <ul>
                        <li v-for="guarantee in annotation.guarantees" :key="guarantee._uid">
                            {{ getOptionLabel(guarantee) }}
                        </li>
                    </ul>
                    <typo name="body-14-normal" v-if="annotation.body" v-html="annotation.body">
                        {{ annotation.body }}
                    </typo>
                    <div v-if="filteredTags.length > 0" class="tags-container">
                        <span v-for="tag in filteredTags" :key="tag._uid" class="insurer-badge">
                            {{ getOptionLabel(tag) }}
                        </span>
                    </div>
                </div>
            </div>
        </v-card>
    </typo>
</template>

<script>
import Vue from "vue";
import { Services } from "src/services/Services";
import { get, isArray, upperFirst } from "lodash";

export default Vue.extend({
    props: ["annotation", "insurers", "annotationOptions"],
    data() {
        return {
            annotationsDico: this.$privateDico.convention.annotations,
        };
    },
    computed: {
        cspClasses() {
            return this.annotation.cspCodes
                .map(code => `csp-${code}`)
                .join(" ")
                .toLowerCase();
        },
        annotationInsurers() {
            if (!isArray(this.annotation.insurerCodes)) return [];
            return this.annotation.insurerCodes.map(insurer => get(this.insurers, insurer, ""));
        },
        insuranceTypeLabel() {
            const label = get(this.annotationOptions, `${this.annotation.insuranceType}.label`, "");
            return upperFirst(label.toLowerCase());
        },
        startDate() {
            return this.formatDate(this.annotation.startDate);
        },
        expiryDate() {
            return this.formatDate(this.annotation.expiryDate);
        },
        filteredTags() {
            return this.annotation.tags.filter(tag => tag !== "compact-info");
        },
    },
    methods: {
        formatDate(date) {
            const isDate = Services.moment(date).isValid();
            return isDate ? Services.moment(date).format("DD/MM/YYYY") : "";
        },
        getOptionLabel(code) {
            return upperFirst(get(this.annotationOptions, `${code}.label`, "").toLowerCase());
        },
    },
});
</script>

<style lang="sass" scoped>
.insurer-wrapper
    margin: 16px 0

.insurer-card
    display: flex
    width: 100%
    align-items: stretch

    .insurer-body
        width: 50%
        padding: 24px
        background-color: #e1f9bc

        .insurer-list
            font-size: 16px
            font-weight: bold
            margin-bottom: 16px
            margin-top: 0
            li
                margin-top: 0

        .insurer-dates
            padding-left: 24px
            margin-bottom: 20px

    .insurer-guaranties
        padding: 24px
        width: 50%

.insurer-badge
    display: inline-block
    border: 1px solid $color-secondary
    border-radius: 4px
    padding: 4px 16px
    margin: 1px 0

.tags-container
    border-top: 1px solid $color-grey
    width: 100%
    padding: 16px 24px
</style>
